import React from 'react';
import { Card, CardBody, CardText, CardTitle } from 'react-bootstrap';
import { Container, Row, Col } from 'react-bootstrap';
import { GoTopBtn } from '../components/GoTopBtn';
import './Supports.css';

import { SuppTouchCon } from "../assets/SupportsData";
import { SuppTouchCar } from "../assets/SupportsData";
import { SuppTouchHmi } from "../assets/SupportsData";
import { SuppTouchInd } from "../assets/SupportsData";
import { SuppTouchLag } from "../assets/SupportsData";

import SuppTouchConImg from '../images/SupportImg/SuppTouchCon.jpg';
import SuppTouchCarImg from '../images/SupportImg/SuppTouchCar.jpg';
import SuppTouchHmiImg from '../images/SupportImg/SuppTouchHmi.jpg';
import SuppTouchIndImg from '../images/SupportImg/SuppTouchInd.jpg';
import SuppTouchLagImg from '../images/SupportImg/SuppTouchLag.jpg';

function SuportTouch() {
  // console.log("get into SuppTouch()");
  return (
    <div className='supporttouch-page'>
      <header className='mt-5'>
        <Container className='h-100 d-flex align-items-center justify-content-center'>
          <h1 className='text-light'>Support / Touch Panel</h1>
        </Container>
      </header>

      <section id='supptouchcom' className='supptouch bg-info-subtle text-dark my-4'>
        <Container>
          <h2 className='title-holder fs-1 fw-bold text-primary'>Support/Touch Consumer</h2>
          <Row>
            {/* <Row className='row flex-column-reverse flex-lg-row'> */}
            <Col lg={6} className='d-flex justify-content-center'>
              <img style={{ height: '80vh' }} src={SuppTouchConImg} className='mt-5 mt-lg-0' alt="" />
            </Col>
            <Col lg={6} className='d-flex flex-column justify-content-around'>
              {SuppTouchCon.map((touch) => (
                <Row key={touch.id}>
                  <Card className='bg-info-subtle border-1 p-0 m-0'>
                    <CardBody className='d-flex justify-content-center'>
                      <CardTitle className='fs-2 text-primary px-3 my-1'> {touch.name} </CardTitle>
                      <CardText className='fs-4'>
                        <a href={`/ListingTouchsBySize/${touch.size}`} className='btn suppbtn-success'> {touch.text} </a>
                      </CardText>
                    </CardBody>
                  </Card>
                </Row>
              ))}
            </Col>
          </Row>
        </Container>
      </section>

      <section id='supptouchcar' className='supptouch bg-primary-subtle text-dark my-4'>
        <Container>
          <h2 className='title-holder fs-1 fw-bold text-success'>Support/Touch Car</h2>
          <Row>
            <Col lg={6} className='d-flex flex-column justify-content-around'>
              {SuppTouchCar.map((touch) => (
                <Row key={touch.id}>
                  <Card className='bg-primary-subtle border-1 p-0 m-0'>
                    <CardBody className='d-flex justify-content-center'>
                      <CardTitle className='fs-2 text-success px-3 my-1'> {touch.name} </CardTitle>
                      <CardText className='fs-4'>
                        <a href={`/ListingTouchsBySize/${touch.size}`} className='btn suppbtn-primary'> {touch.text} </a>
                      </CardText>
                    </CardBody>
                  </Card>
                </Row>
              ))}
            </Col>
            <Col lg={6} className='d-flex justify-content-center'>
              <img style={{ height: '60vh' }} src={SuppTouchCarImg} className='mt-4 mt-lg-0' alt="" />
            </Col>
          </Row>
        </Container>
      </section>

      <section id='supptouchhmi' className='supptouch bg-info-subtle text-dark my-4'>
        <Container>
          <h2 className='title-holder fs-1 fw-bold text-primary'>Support/Touch HMI</h2>
          <Row>
            <Col lg={6} className='d-flex justify-content-center'>
              <img style={{ height: '80vh' }} src={SuppTouchHmiImg} className='mt-5 mt-lg-0' alt="" />
            </Col>
            <Col lg={6} className='d-flex flex-column justify-content-around'>
              {SuppTouchHmi.map((touch) => (
                <Row key={touch.id}>
                  <Card className='bg-info-subtle border-1 p-0 m-0'>
                    <CardBody className='d-flex justify-content-center'>
                      <CardTitle className='fs-2 text-primary px-3 my-1'> {touch.name} </CardTitle>
                      <CardText className='fs-4'>
                        <a href={`/ListingTouchsBySize/${touch.size}`} className='btn suppbtn-success'> {touch.text} </a>
                      </CardText>
                    </CardBody>
                  </Card>
                </Row>
              ))}
            </Col>
          </Row>
        </Container>
      </section>

      <section id='supptouchind' className='supptouch bg-primary-subtle text-dark my-4'>
        <Container>
          <h2 className='title-holder fs-1 fw-bold text-success'>Support/Touch Industary</h2>
          <Row>
            <Col lg={6} className='d-flex flex-column justify-content-around'>
              {SuppTouchInd.map((touch) => (
                <Row key={touch.id}>
                  <Card className='bg-primary-subtle border-1 p-0 m-0'>
                    <CardBody className='d-flex justify-content-center'>
                      <CardTitle className='fs-2 text-success px-3 my-1'> {touch.name} </CardTitle>
                      <CardText className='fs-4'>
                        <a href={`/ListingTouchsBySize/${touch.size}`} className='btn suppbtn-primary'> {touch.text} </a>
                      </CardText>
                    </CardBody>
                  </Card>
                </Row>
              ))}
            </Col>
            <Col lg={6} className='d-flex justify-content-center'>
              <img style={{ height: '70vh' }} src={SuppTouchIndImg} className='mt-4 mt-lg-0' alt="" />
            </Col>
          </Row>
        </Container>
      </section>

      <section id='supptouchlag' className='supptouch bg-info-subtle text-dark my-4'>
        <Container>
          <h2 className='title-holder fs-1 fw-bold text-primary'>Support/Touch Large</h2>
          <Row>
            <Col lg={6} className='d-flex justify-content-center'>
              <img style={{ height: '80vh' }} src={SuppTouchLagImg} className='mt-5 mt-lg-0' alt="" />
            </Col>
            <Col lg={6} className='d-flex flex-column justify-content-around'>
              {SuppTouchLag.map((touch) => (
                <Row key={touch.id}>
                  <Card className='bg-info-subtle border-1 p-0 m-0'>
                    <CardBody className='d-flex justify-content-center'>
                      <CardTitle className='fs-2 text-primary px-3 my-1'> {touch.name} </CardTitle>
                      <CardText className='fs-4'>
                        <a href={`/ListingTouchsBySize/${touch.size}`} className='btn suppbtn-success'> {touch.text} </a>
                      </CardText>
                    </CardBody>
                  </Card>
                </Row>
              ))}
            </Col>
          </Row>
        </Container>
      </section>
      <div> < GoTopBtn /> </div>
    </div>
  )
}

export default SuportTouch;